import { t as StyledSvgIcon } from "./SvgIcon.styles-D2P4wvY9.js";
import * as React$1 from "react";
import { jsx } from "react/jsx-runtime";

//#region src/assets/icons/custom/JotBill.svg?react
const SvgJotBill = (props) => /* @__PURE__ */ React$1.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 148.5 346.5",
	...props
}, /* @__PURE__ */ React$1.createElement("g", { fill: "#1C1E85" }, /* @__PURE__ */ React$1.createElement("rect", {
	x: 52.5,
	y: 3,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 52.5,
	y: 102,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 52.5,
	y: 201,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 52.5,
	y: 300,
	width: 43.5,
	height: 43.5,
	rx: 9.2
})), /* @__PURE__ */ React$1.createElement("g", { fill: "#FD96C9" }, /* @__PURE__ */ React$1.createElement("rect", {
	x: 3,
	y: 52.5,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 52.5,
	y: 52.5,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 102,
	y: 52.5,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 3,
	y: 102,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 3,
	y: 151.5,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 52.5,
	y: 151.5,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 102,
	y: 151.5,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 102,
	y: 201,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 3,
	y: 250.5,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 52.5,
	y: 250.5,
	width: 43.5,
	height: 43.5,
	rx: 9.2
}), /* @__PURE__ */ React$1.createElement("rect", {
	x: 102,
	y: 250.5,
	width: 43.5,
	height: 43.5,
	rx: 9.2
})));

//#endregion
//#region src/icons/JotBillIcon.tsx
function JotBillIcon(props) {
	return /* @__PURE__ */ jsx(StyledSvgIcon, {
		component: SvgJotBill,
		inheritViewBox: true,
		...props
	});
}

//#endregion
export { JotBillIcon as t };
//# sourceMappingURL=JotBillIcon-C6AE1nIe.js.map